$(document).ajaxStop(function () {
  $('.dsgvo-check').click(function () {
    if ($('#cdu-form-dsgvo-checkbox01')[0].checked === true) {
      $('#cdu-form-dsgvo-checkbox01')[0].checked = false;
    } else {
      $('#cdu-form-dsgvo-checkbox01')[0].checked = true;
    }
  });
});
